import React from 'react';
import Currency from './Currency';
import ContentView from '../../Layouts/ContentView';
const index = () => {
    return (
        <ContentView>
            <Currency />
        </ContentView>
    )
}
export default index;
